import { useMemo } from 'react'
import { useParams } from 'react-router-dom'

import { LoadContentDocument } from 'generated/resources/graphql'

import { F0Button as Button } from '@factorialco/f0-react'
import { observer } from 'mobx-react'

import Loading from 'modules/core/components/Loading'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import ContentConsumer from 'modules/trainings/components/content/Consumer'
import { graphqlContentMapper } from 'modules/trainings/lib/content/mappers'
import { Box, Divider } from '@factorialco/deprecated-design-system'
import i18n from 'modules/core/lib/i18n'
import { FeatureWall } from 'modules/core/components/FeatureWall'

export default observer(() => {
  const { trainingId } = useParams()

  const { data, loading } = useQuery(LoadContentDocument, {
    variables: {
      trainingId: Number(trainingId),
      //TODO: Pass employee id
    },
  })

  const collection = useMemo(() => {
    const modules = data?.trainings.contentModules
    if (loading || !modules) {
      return null
    }
    return graphqlContentMapper.fromGraphQL(modules, Number(trainingId))
  }, [trainingId, data, loading])

  if (!collection || loading) {
    return <Loading expand />
  }

  if (!collection.selectedItem) return null

  return (

    <FeatureWall featureName="dev_training_lms">
      <ResponsivePage.Body variant="fullscreen">
        <ContentConsumer
          tocItems={collection.modules.map((contentModule) => ({
            id: contentModule.uuid,
            label: contentModule.title,
            onClick: () => collection.setSelected(contentModule.uuid),
            children: contentModule.blocks.map((block) => ({
              id: block.uuid,
              label: block.title,
              onClick: () => collection.setSelected(block.uuid),
              disabled: false // TODO: Disabled based on availability
            })),
            disabled: false, // TODO: Disabled based on availability
          }))}
          selectedItem={collection.selectedItem}
        />
        <Divider />
        <Box flexDirection="row" justifyContent="flexEnd" gap="s16" padding="s16" width="full" paddingRight="s64">
          {/* TODO: Add calculated percentage here */}
          <Box gap="s16" flexDirection="row">
            <Button label={i18n.t("trainings.content.consumer.back")} variant="secondary" onClick={() => {
              collection.back()
            }} />
            <Button label={i18n.t("trainings.content.consumer.continue")} disabled={false} onClick={() => {
              collection.next()
            }} /> {/* Disable based on computed completion on the contentItem */}
          </Box>
        </Box>
      </ResponsivePage.Body>
    </FeatureWall>
  )
})
